import script from "./twoLangDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./twoLangDialog.vue?vue&type=script&lang=ts&setup=true"

import "./twoLangDialog.vue?vue&type=style&index=0&id=716f043b&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-716f043b"]])

export default __exports__